import { createFileRoute } from "@tanstack/react-router";
import type { FC } from "react";
import { ForbiddenError } from "../../../../../errors/ForbiddenError";
import { fetchVendor } from "../../../../../services/vendors";
import { VendorProfileDetails } from "./-internal_components/VendorProfileDetails";
import { Route as VendorRoute } from "./route";

const RouteComponent: FC = () => {
  const vendor = VendorRoute.useLoaderData();

  return <VendorProfileDetails vendor={vendor} />;
};

export const Route = createFileRoute(
  "/_private/vsupplierregistration/vendors/$vendorId/",
)({
  beforeLoad({ context }) {
    const user = context.auth.user;

    if (!user) {
      throw new ForbiddenError();
    }

    if (
      user.roles_names.includes("View All Vendors") ||
      user.roles_names.includes("Edit All Vendors")
    ) {
      return;
    }

    throw new ForbiddenError();
  },
  component: RouteComponent,
  loader: ({ params: { vendorId } }) => fetchVendor(parseInt(vendorId, 10)),
});
